import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { ButtonGroup, Button } from 'uikit/buttons';

import styles from '../styles/toggleButtons.module.scss';

const ToggleButtons = ({
  ariaLabel = '',
  buttons = [],
  color = 'primary',
  isDisabled = false,
  onChange = () => {},
  value = null,
}) => {
  const CLASSES = {
    color: {
      primary: styles.isColorPrimary,
      brand: styles.isColorBrand,
    },
  };

  return (
    <section aria-label={ariaLabel}>
      <ButtonGroup variant="outlined" isSpaced={false}>
        {buttons.map(({ label, value: buttonValue }) => {
          const isActive = buttonValue === value;

          return (
            <Button
              aria-pressed={isActive}
              className={classnames(
                styles.element,
                isActive && styles.isActive,
                { [CLASSES.color[color]]: color },
              )}
              isDisabled={isDisabled}
              key={buttonValue}
              onClick={() => onChange(buttonValue)}
              size="small"
              text={label}
              variant="outlined"
            />
          );
        })}
      </ButtonGroup>
    </section>
  );
};

ToggleButtons.propTypes = {
  ariaLabel: PropTypes.string,
  buttons: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string]),
  })),
  color: PropTypes.oneOf(['primary', 'brand']),
  isDisabled: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string]),
};

export default React.memo(ToggleButtons);
